module.exports = __webpack_public_path__ + "img/51.abadd34e.jpg";